module.exports = __webpack_public_path__ + "5953aa16885b79cfdd1a53fc2cd296cb.pdf";